import { ITranslationsContext } from "providers/Translations/TranslationsContext";

export function isAnonymizedUser(displayName: string | undefined | null): boolean {
  return !!displayName?.toLowerCase().startsWith("anonymized-");
}

export function getAnonymizedAwareDisplayName(
  displayName: string | undefined | null,
  i18n: ITranslationsContext
): string {
  if (isAnonymizedUser(displayName)) {
    return i18n.User_AnonymizedDisplayName;
  }

  return displayName ?? "";
}
